import {
  withTranslation,
} from 'react-i18next';

import PaymentDialogView from './PaymentDialogView';

const TranslatedComponent = withTranslation()(PaymentDialogView);

const Component = TranslatedComponent;

export default Component;
